import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "vote-form__slider-content" }
const _hoisted_2 = {
  key: 0,
  class: "vote-form__slider-navbar"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "vote-form__slider-button-text" }, "Mégse", -1)
const _hoisted_5 = {
  key: 1,
  class: "vote-form__slider-navbar"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "vote-form__slider-button-text" }, "Előző", -1)
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "vote-form__slider-button-text" }, "Következő", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vote_question = _resolveComponent("vote-question")!
  const _component_close = _resolveComponent("close")!
  const _component_container = _resolveComponent("container")!
  const _component_slider_left = _resolveComponent("slider-left")!
  const _component_slider_right = _resolveComponent("slider-right")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vote-form", { 'vote-form--has-selection': !!_ctx.selectedSubjects[_ctx.question.id] }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vote.form.questions, (question, key) => {
        return (_openBlock(), _createBlock(_component_vote_question, {
          class: _normalizeClass(["vote-form__question", { 'vote-form__question--active': key === _ctx.slideIndex }]),
          ref_for: true,
          ref: "slides",
          key: key,
          title: question.title,
          type: question.type,
          text: key === _ctx.slideIndex ? question.text : null,
          subjects: question.subjects,
          min: question.min,
          max: question.max,
          name: `vote[${key}]`,
          readonly: _ctx.readonly,
          modifiable: _ctx.vote.form.modifiable,
          selectable: _ctx.vote.form.batchable,
          "persisted-data": _ctx.persistedValue[question.id],
          modelValue: _ctx.formValue[question.id],
          "onUpdate:modelValue": ($event: any) => ((_ctx.formValue[question.id]) = $event),
          selectedSubject: _ctx.selectedSubjects[question.id],
          "onUpdate:selectedSubject": ($event: any) => ((_ctx.selectedSubjects[question.id]) = $event)
        }, null, 8, ["class", "title", "type", "text", "subjects", "min", "max", "name", "readonly", "modifiable", "selectable", "persisted-data", "modelValue", "onUpdate:modelValue", "selectedSubject", "onUpdate:selectedSubject"]))
      }), 128))
    ]),
    (_ctx.selectedSubjects[_ctx.question.id])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_container, { class: "vote-form__slider-navcontent" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                class: "vote-form__slider-button vote-form__slider-button--close",
                disabled: _ctx.readonly,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelSelection()))
              }, [
                _hoisted_4,
                _createVNode(_component_close, { class: "vote-form__slider-button-icon" })
              ], 8, _hoisted_3)
            ]),
            _: 1
          })
        ]))
      : (_ctx.slidesNum > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_container, { class: "vote-form__slider-navcontent" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "vote-form__slider-button vote-form__slider-button--prev",
                  disabled: _ctx.slideIndex <= 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.slideIndex--))
                }, [
                  _createVNode(_component_slider_left, { class: "vote-form__slider-button-icon" }),
                  _hoisted_7
                ], 8, _hoisted_6),
                _createElementVNode("button", {
                  type: "button",
                  class: "vote-form__slider-button vote-form__slider-button--next",
                  disabled: _ctx.slideIndex >= _ctx.slidesNum - 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.slideIndex++))
                }, [
                  _hoisted_9,
                  _createVNode(_component_slider_right, { class: "vote-form__slider-button-icon" })
                ], 8, _hoisted_8)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
  ], 2))
}